import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  table: css`
    padding-block: ${spacing(2)};
  `,
  longTextCell: css`
    padding-inline-start: ${spacing(6)};
    text-align: right;
    word-break: break-word;
  `,
}
